import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import * as messageConstants from '../../../shared/messages';
import validate from '../../../utils/validate';
import * as samlConstants from '../../../constants/samlConstants';

class ImportMetadata extends Component {
  state = {
    selectedFileName: '',
    selectedFile: "",
    errors: []
  }
  handleHideImportModal = () => {
    this.clearState();
    this.props.handleHideImportModal();
  }

  clearState = () => {
    this.setState({
      selectedFileName: '',
      selectedFile: "",
      errors: []
    });
  }

  handleClickImportSpMetadata = () => {
    this.inputImportSpMetadata.value = "";
    this.inputImportSpMetadata.click();
  }

  handleSelectSpMetadataFile = (event) => {
    if (event.target.files.length > 0) {
      this.setState({selectedFileName: event.target.files[0].name});
      this.setState({selectedFile: event.target.files[0]});
    }
  }

  handleImportUrl = () => {
    if (!this.state.errors || (this.state.errors
        && !this.state.errors.downloadUrl)) {
      this.props.handleImportFromUrl(this.props.downloadUrl);
      this.handleHideImportModal();
    }
  };

  handleUpdateImportUrl = (e) => {
    this.props.handleUpdateDownloadUrl(e.target.value);
  }

  handleChangeSelectedImportOption = (e) => {
    this.props.handleChangeSelectedImportOption(e.target.value)
  }

  handleImportSpMetadataXml = () => {
    this.props.handleImportFromXml(this.state.selectedFile);
    this.handleHideImportModal();
  }

  validateAndImportFromUrl = () => {
    this.setState({
      errors: validate({downloadUrl: this.props.downloadUrl}, {
        downloadUrl: {
          presence: {
            allowEmpty: false,
            message: messageConstants.SBA_IMPORT_URL_WARNING
          },
          url: {
            allowLocal: false,
            message: messageConstants.SBA_IMPORT_URL_WARNING
          },
        },
      }, {fullMessages: false})
    }, this.handleImportUrl);
  }

  handleImportStart = () => {
    switch (this.props.selectedImportOption) {
      case samlConstants.IMPORT_FROM_FILE:
        this.handleImportSpMetadataXml();
        break;
      case samlConstants.IMPORT_FROM_URL:
        this.validateAndImportFromUrl();
        break;
      default:
        break;
    }
  }

  handleKeyPressed = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleImportStart()
    }
  }

  render() {
    const isImportFromFile = this.props.selectedImportOption
        === samlConstants.IMPORT_FROM_FILE;
    const isImportFromUrl = this.props.selectedImportOption
        === samlConstants.IMPORT_FROM_URL;
    const isDownloadUrlError = this.state.errors
        && this.state.errors.downloadUrl;
    return (
        <div className="action-block">
          <Modal
              show={this.props.showImportModal}
              onHide={this.handleHideImportModal}
              container={this}
              aria-labelledby="contained-modal-title"
              dialogClassName="import-modal"
              onKeyPress={this.handleKeyPressed}
          >
            <Modal.Header
                className="basic-modal-header"
            >
              <Modal.Title>
                <span
                    className="basic-modal-header-title">{messageConstants.GET_METADATA}</span>
                <button id="hideImportSpMetadataModalButton"
                        className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideImportModal}/>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body
                className="import-modal-body"
            >
              <div
                  className="import-modal-body-top">{messageConstants.SBA_IMPORT_URL_CHOOSE_IMPORT}
              </div>
              <div className="import-modal-body-middle">
                <form>
                  <div className="form-group">
                    <div>
                      <div className="cp-checkbox-wrapper">
                        <input id="importFromUrl" type="radio"
                               value={samlConstants.IMPORT_FROM_URL}
                               checked={isImportFromUrl}
                               onChange={this.handleChangeSelectedImportOption}/>
                        <label htmlFor="importFromUrl">
                          <span
                              className="radio-button-label">{messageConstants.SBA_IMPORT_FROM_URL}</span>
                        </label>
                      </div>
                      <div className="form-group pl-26">
                        <label
                            className="import-label">{messageConstants.SBA_IMPORT_URL_IMPORT_URL}</label>
                        <input
                            id="parseUrlInput"
                            disabled={!isImportFromUrl}
                            type="text"
                            name="parseUrl"
                            className={isDownloadUrlError
                                ? "form-control import-url-input import-input-warning"
                                : "form-control import-url-input"}
                            onChange={this.handleUpdateImportUrl}
                            value={this.props.downloadUrl}
                            placeholder={messageConstants.SBA_IMPORT_FROM_URL_HINT}
                        />
                        {isImportFromUrl && isDownloadUrlError ? (
                            <span className="help-block warning">
                                        {this.state.errors.downloadUrl[0]}
                                      </span>) : null}
                      </div>
                    </div>
                    <div>
                      <div className="cp-checkbox-wrapper">
                        <input id="importFromXML" type="radio"
                               value={samlConstants.IMPORT_FROM_FILE}
                               checked={isImportFromFile}
                               onChange={this.handleChangeSelectedImportOption}/>
                        <label htmlFor="importFromXML">
                          <span
                              className="radio-button-label">{messageConstants.SBA_IMPORT_FROM_FILE}</span>
                        </label>
                      </div>
                      <div className="form-group pl-26"
                           disabled={!isImportFromFile}>
                        <label
                            className="import-label">{messageConstants.SBA_IMPORT_FROM_FILE_LABEL}</label>
                        <div className="input-group"
                             disabled={!isImportFromFile}>
                          <input
                              type="file"
                              name="spMetadataFile"
                              accept=".xml"
                              className="form-control inputfile"
                              ref={
                                input => this.inputImportSpMetadata = input}
                              onChange={this.handleSelectSpMetadataFile}
                          />
                          <div id="importXmlFileName"
                              className={isImportFromFile
                              ? this.state.selectedFileName
                                  ? "form-control import-file-input"
                                  : "form-control import-file-input import-file-hint"
                              : "form-control import-file-input import-file-controls-disabled"}
                               disabled={!isImportFromFile}>
                            {this.state.selectedFileName
                                ? this.state.selectedFileName
                                : messageConstants.SBA_IMPORT_FROM_FILE_HINT}
                          </div>
                          <span
                              className=
                                  {isImportFromFile
                                      ? "input-group-btn import-file-controls import-file-controls-enabled"
                                      : "input-group-btn import-file-controls import-file-controls-disabled"}>
                  <button
                      id="importSpMetadatabrowseButton"
                      disabled={!isImportFromFile}
                      className="btn import-browse-button"
                      type="button"
                      onClick={this.handleClickImportSpMetadata}
                  >
                    {messageConstants.SBA_IMPORT_FILE_BROWSE}
                  </button>
                </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="import-modal-body-bottom">
                <button
                    id="hideImportSpMetadataModalButton"
                    className="btn import-ok-button"
                    type="button"
                    onClick={this.handleImportStart}
                >
                  {messageConstants.OK}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
    );
  }

}

export default ImportMetadata;
